module.exports = __webpack_public_path__ + "img/amex.23cd5a21.svg";